import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('cloud-providers')
export class Provider extends Resource {
    public type: string;
    public name: string;
}
